// extracted by mini-css-extract-plugin
export var dropdown = "teamDeptInput-module--dropdown--ca034";
export var dropdownContainer = "teamDeptInput-module--dropdownContainer--396bc";
export var tag = "teamDeptInput-module--tag--141d7";
export var tagDescription = "teamDeptInput-module--tagDescription--ab587";
export var tagInput = "teamDeptInput-module--tagInput--73a9f";
export var tagLabel = "teamDeptInput-module--tagLabel--b99d1";
export var tags = "teamDeptInput-module--tags--f0260";